<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-14 18:23:36
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-04-07 12:43:41
 * @Description: 描述
 -->
<template>
  <a-divider :orientation="options.contentPosition"
    v-if="!options.hidden">{{label}}</a-divider>
</template>
<script>
import props from '../../lib/props';

export default {
  name: 'wgDivider',
  mixins: [props],
  data() {
    return {};
  },
};
</script>
